export default "__VITE_ASSET__fbf26555__"